import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@mui/material";
import LoadingSpinner from "../../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { StripedRows } from "../../styles";
import { ExpenseForEmployment } from "./types";

type Props = {
  payloadData: ExpenseForEmployment[];
  headers: string[];
  isLoading: boolean;
};

const ExpensesForEmploymentTables = ({
  payloadData,
  headers,
  isLoading,
}: Props) => {
  const sortedData = payloadData.sort(
    (a, b) =>
      new Date(a.date).getTime() - new Date(b.date).getTime() ||
      new Date(a.entryDate).getTime() - new Date(b.entryDate).getTime(),
  );

  const renderTableHeaders = () => {
    return (
      <TableHead>
        {headers.map((key) => (
          <TableCell key={key}>{key}</TableCell>
        ))}
      </TableHead>
    );
  };

  const renderTableCell = (key: string, row: ExpenseForEmployment) => {
    switch (key) {
      case "employmentId":
      case "talentId":
      case "unit":
        return null;
      case "amount":
        return (
          <TableCell
            key={`${row.id}_${key}`}
            sx={{ whiteSpace: "nowrap" }}
            size="small"
          >{`${row[key]}${row.unit}`}</TableCell>
        );
      default:
        return (
          <TableCell
            key={`${row.id}_${key}`}
            sx={{ whiteSpace: "nowrap" }}
            size="small"
          >
            {String(row[key])}
          </TableCell>
        );
    }
  };

  const renderTableBody = () => {
    return (
      <TableBody>
        {sortedData.map((row) => (
          <StripedRows key={row.id}>
            {headers.map((key) => renderTableCell(key, row))}
          </StripedRows>
        ))}
      </TableBody>
    );
  };

  return (
    <Grid sx={{ maxWidth: "1600px" }}>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <TableContainer>
          <Table>
            {renderTableHeaders()}
            {renderTableBody()}
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
export default ExpensesForEmploymentTables;
